<template>
  <div>
    <b-container fluid>
      <!-- <h3 class="mt-3 mb-3">Route Allocation</h3> -->
      <b-row>
        <b-col cols="3">
          <h3 class="mt-3 mb-3">Route Allocation</h3>
        </b-col>
        <b-col cols="2" style="display: flex; align-items:center;">
          <b-form-select size="lg" v-model="search_criteria.show_history_record" :options="history_record_option"
            @change="onChangeShowHistoryRecord" style="align-self: center">
            Show History Record
          </b-form-select>
        </b-col>
        <b-col cols="4" style="display: flex; align-items:center;">

          <b-form-input id="input-small" size="lg" type="date" v-model="search_criteria.scheduled_delivery_date"
            :disabled="search_criteria.show_history_record == 'show_history_record'"></b-form-input>
          <b-button size="lg" variant="info" @click="onSearch">
            <font-awesome-icon class="mr-1" icon="sync" />
          </b-button>
        </b-col>
      </b-row>

      <b-card class="mb-1" v-if="$store.state.user_obj.account_type != 'driver_route'">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select size="sm" v-model="update_route_obj.route" :options="tracking_route_options" />
          </b-col>
          <b-col cols="3" class="pl-0 pr-1">
            <b-form-input ref="txt_order_number" size="sm" type="text" placeholder="Tracking#"
              v-model="update_route_obj.tracking_number" v-on:keyup.enter="updateRoute()"></b-form-input>
          </b-col>
          <b-col cols="2" class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="danger" @click="updateRoute">
              Add to Cart
            </b-button>
          </b-col>

          <b-col class="p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="removeRoute">
              Remove From Cart
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <div class="search_bar mb-1">
        <b-card>
          <!-- <b-row class="mb-1">
            <b-col cols="2" class="pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.channel_selected"
                :options="channel_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.order_status_selected"
                :options="order_status_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.stock_status_selected"
                :options="stock_status_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.fulfilment_status_selected"
                :options="fulfilment_status_options"
              />
            </b-col>
          </b-row> -->
          <b-row>
            <b-col cols="2" class=" pr-1">
              <b-form-select size="sm" v-model="search_criteria.client_selected" multiple :options="client_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.courier_selected" :options="courier_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.route_selected"
                :options="search_tracking_route_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.tracking_status_selected"
                :options="tracking_status_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.cart_status_selected" :options="cart_status_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.inout_warehouse" :options="inout_warehouse_options" />
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="3" class="pr-1">
              <b-form-input id="input-small" size="sm" type="text" placeholder="Order#/Tracking#"
                v-model="search_criteria.keyword" @keyup.enter="onSearch"></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input id="input-small" size="sm" type="text" placeholder="Packing Sector"
                v-model="search_criteria.packing_sector" @keyup.enter="onSearch"></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.tier_selected" :options="tracking_tier_options" />
            </b-col>
            <!-- <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.start_at"
              ></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.end_at"
              ></b-form-input>
            </b-col> -->
            <b-col class="text-left p-0">
              <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button>
              <b-button class="btn-action" size="sm" variant="info" @click="onExport">
                Export
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <div class="search_bar mb-3">
        <b-card>
          <div style="margin-bottom: 19px">
            <b-form-checkbox v-model="carton_cnt_checked" name="check-button" switch>
              Show Carton Count
            </b-form-checkbox>
          </div>
          <b-row :key="ri" v-for="(route_count, ri) in (carton_cnt_checked == true ? route_ctns_counts : route_counts)">
            <b-col class="mt-1" cols="2" :key="rdi" v-for="(route_count_detail, rdi) in route_count">
              <div class="cusor_pointer route_box">
                <strong>
                  {{ rdi }}
                </strong>
                <div class="row-status_cnt" @click="onSearchByRoute('pending', rdi)">
                  <div style="width: 90px;">Pending</div>
                  <div>
                    <span class="dot_red"></span>
                    <span>
                      {{ route_count_detail["pending"] }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="onSearchByRoute('reserved', rdi)">
                  <div style="width: 90px;">Reserved</div>
                  <div>
                    <span class="dot_yellow"></span>
                    <span>
                      {{ route_count_detail["reserved"] }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="onSearchByRoute('on_cart', rdi)">
                  <div style="width: 90px;">On Cart</div>
                  <div>
                    <span class="dot_green"></span>
                    <span>
                      {{ route_count_detail["on_cart"] }}/{{
                        parseInt(route_count_detail["on_cart"]) +
                        parseInt(route_count_detail["reserved"])
                      }}
                    </span>
                  </div>
                </div>

                <!-- <div
                  class="row-status_cnt"
                  @click="onSearchByRoute('shipped', rdi)"
                >
                  <div style="width: 90px;">Shipped</div>
                  <div>
                    <span class="dot_white"></span>
                    <span>
                      {{ route_count_detail["shipped"] }}/{{ parseInt(route_count_detail["on_cart"]) + parseInt(route_count_detail["shipped"])}}
                    </span>
                  </div>
                </div>

                <div
                  class="row-status_cnt"
                  @click="onSearchByRoute('total', rdi)"
                >
                  <div style="width: 90px;">Total</div>
                  <div>
                    <span class="dot_white"></span>
                    <span>
                      {{ route_count_detail["total"] }}
                    </span>
                  </div>
                </div> -->
              </div>
            </b-col>
          </b-row>
          <hr />

          <b-row class="mt-1 mb-1" v-if="$store.state.user_obj.account_type != 'driver_route'">
            <b-col class="">
              <b-button class="btn-action" size="sm" variant="info" @click="onBulkAction('reserved')">
                Bulk Reserve
              </b-button>

              <b-button class="btn-action" size="sm" variant="info" @click="onBulkAction('pending')">
                Bulk Un-Reserve
              </b-button>

              <b-button class="btn-action" size="sm" variant="info" @click="openRescheduleModal" v-if="$store.state.user_obj && ($store.state.user_obj.account_type == 'admin' || $store.state.user_obj.account_type == 'client_admin') ">
                Bulk Reschedule
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <strong># of Records: {{ total_rows }}</strong>

      <b-row class="mb-1">
        <b-col cols="1" class="pr-0">
          <b-form-select size="sm" v-model="sel_table_limit" :options="[50, 100, 200, 500]"
            @change="getRouteAllocations()" />
        </b-col>
        <b-col class="pl-0 pr-1">
          <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
            @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
        </b-col>
      </b-row>

      <b-table responsive small outlined striped hover :items="items" :fields="fields" :tbody-tr-class="rowClass">
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox size="sm" plain id="chkbox_all" value="all" v-model="check_all_rows"></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"></b-form-checkbox>
        </template>

        <template v-slot:cell(schedule_date)="data">
          {{ displayDate(data.item.schedule_date) }}
        </template>

        <template v-slot:cell(order_number)="data">
          <router-link :to="{
            name: 'order_master_detail',
            params: { order_master_id: data.item.order_id }
          }" v-if="$store.state.user_obj.account_type != 'driver_route'">
            {{ data.item.order_number }}
          </router-link>

          <div v-if="$store.state.user_obj.account_type == 'driver_route'">
            {{ data.item.order_number }}
          </div>
        </template>

        <template v-slot:cell(tracking_number)="data">
          <router-link :to="{
            name: 'tracking_detail',
            params: { id: data.item.id }
          }" v-if="$store.state.user_obj.account_type != 'driver_route'">
            {{ data.item.tracking_number }}
          </router-link>

          <div v-if="$store.state.user_obj.account_type == 'driver_route'">
            {{ data.item.tracking_number }}
          </div>
        </template>

        <!-- <template v-slot:cell(payment_status)="data">
          -
        </template> -->

        <template v-slot:cell(order_import_status)="data">
          <div>
            <span class="span-status">{{ data.item.order_import_status }}</span>

            <span v-if="data.item.order_import_status == 'cancel'" class="dot_red"></span>
            <span v-if="data.item.order_import_status == 'hold'" class="dot_red"></span>
            <span v-if="data.item.order_import_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.order_import_status == 'received'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(stock_status)="data">
          <div>
            <span class="span-status">{{ data.item.stock_status }}</span>

            <span v-if="data.item.stock_status == '-'" class="dot_white"></span>
            <span v-if="data.item.stock_status == 'pending'" class="dot_red"></span>
            <span v-if="data.item.stock_status == 'available'" class="dot_yellow"></span>
            <span v-if="data.item.stock_status == 'committed'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(cart)="data">
          <div>
            <span v-if="data.item.cart">{{ data.item.cart }}</span>
            <span v-if="!data.item.cart">-</span>
          </div>
        </template>

        <template v-slot:cell(fulfilment_status)="data">
          <div>
            <span class="span-status">{{ data.item.fulfilment_status }}</span>

            <span v-if="data.item.fulfilment_status == '-'" class="dot_white"></span>
            <span v-if="data.item.fulfilment_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.fulfilment_status == 'completed'" class="dot_green"></span>
            <span v-if="data.item.fulfilment_status == 'fulfiled'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(cart_status)="data">
          <div>
            <span v-if="data.item.cart_status == 'pending'" class="dot_red"></span>
            <span v-if="data.item.cart_status == 'reserved'" class="dot_yellow"></span>
            <span v-if="data.item.cart_status == 'on_cart'" class="dot_green"></span>
            <span v-if="data.item.cart_status == 'shipped'" class="dot_white"></span>

            <span>{{ data.item.cart_status }}</span>
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <b-button v-if="$store.state.user_obj.account_type != 'driver_route'" class="btn-action" size="sm"
            variant="danger" :disabled="data.item.order_import_status == 'cancel'"
            @click="cancelRoute(data.item)">Cancel</b-button>
        </template>

        <template v-slot:cell(order_date)="data">
          {{ displayDate(data.item.order_date) }}
        </template>

        <template v-slot:cell(scheduled_delivery_date)="data">
          {{ displayDate(data.item.scheduled_delivery_date) }}
        </template>
      </b-table>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
    </b-container>

    <b-modal id="reschedule-modal" title="Bulk Reschedule" :hide-footer="true" @hide="clearRescheduleForm">
      <b-form-group label="Reschedule Date" label-for="reschedule-date-input">
        <b-form-input id="reschedule-date-input" type="date" v-model="rescheduleDate"
          placeholder="dd/mm/yyyy"></b-form-input>
      </b-form-group>

      <b-form-group label="Selected Tracking Numbers">
        <ul>
          <li v-for="tracking in selectedTrackingNumbers" :key="tracking">
            {{ tracking }}
          </li>
        </ul>
      </b-form-group>

      <!-- Left-aligned action buttons using flexbox -->
      <div class="d-flex justify-content-end">
        <b-button variant="secondary" @click="$bvModal.hide('reschedule-modal')">Cancel</b-button>
        <b-button variant="primary" class="ml-2" @click="confirmReschedule">Confirm</b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";

const fields = [
  {
    key: "chk_box",
    label: ""
  },
  {
    key: "order_date",
    label: "Order Date"
  },
  {
    key: "scheduled_delivery_date",
    label: "Schedule Delivery"
  },
  {
    key: "client_name",
    label: "Client"
  },
  {
    key: "courier_short_name",
    label: "Courier"
  },
  {
    key: "order_number",
    label: "Order#"
  },
  {
    key: "tracking_number",
    label: "Tracking#"
  },
  {
    key: "ctns",
    label: "Cartons",
    class: "center_align"
  },
  {
    key: "cart_status",
    label: "Cart Status",
    class: " center_align"
  },
  {
    key: "route",
    label: "Route",
    class: "txt_camelcase center_align"
  },
  {
    key: "cart",
    label: "Cart",
    class: "txt_camelcase center_align"
  },
  {
    key: "district",
    label: "District",
    class: "txt_camelcase center_align"
  },
  {
    key: "status",
    label: "Status",
    class: "txt_camelcase center_align"
  },
  {
    key: "action",
    label: "Action"
  }
];

export default {
  name: "OrderMaster",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      rescheduleDate: null,
      selectedTrackingNumbers: [],
      update_route_obj: {
        tracking_number: ""
      },
      tracking_route_options: [],
      search_tracking_route_options: [],
      sel_table_limit: this.TABLE_LIMIT,
      courier_options: [],
      client_options: [
        {
          value: null,
          text: "All Clients"
        }
      ],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: [],
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        channel_selected: null
      },
      search_criteria: {
        keyword: "",
        courier_selected: null,
        client_selected: [],
        channel_selected: null,
        scheduled_delivery_date: moment().hour() < 12 ? moment().format("YYYY-MM-DD") : moment().add(1, "d").format("YYYY-MM-DD"),
        // start_at: moment().format("YYYY-MM-DD"),
        // end_at: moment()
        //   .add(1, "d")
        //   .format("YYYY-MM-DD"),
        order_status_selected: null,
        stock_status_selected: null,
        fulfilment_status_selected: null,
        cart_status_selected: null,
        tracking_status_selected: null,
        status_selected: null,
        route_selected: null,
        tier_selected: null,
        inout_warehouse: 'in-warehouse',
        show_history_record: 'show_by_date',
        packing_sector: null
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      channel_options: [
        {
          value: null,
          text: "All Channel"
        }
      ],

      inout_warehouse_options: [
        {
          value: null,
          text: "In & Out of Warehouse"
        },
        {
          value: "in-warehouse",
          text: "In-Warehouse"
        },
        {
          value: "out-warehouse",
          text: "Out-of-Warehouse"
        },
      ],

      cart_status_options: [
        {
          value: null,
          text: "All Cart Status"
        },
        {
          value: "pending",
          text: "pending"
        },
        {
          value: "reserved",
          text: "reserved"
        },
        {
          value: "on_cart",
          text: "on_cart"
        },
        {
          value: "shipped",
          text: "shipped"
        }
      ],

      order_status_options: [
        {
          value: null,
          text: "All Order Status"
        },
        {
          value: "cancel",
          text: "Cancel"
        },
        {
          value: "received",
          text: "Received"
        },
        {
          value: "pending",
          text: "Pending"
        }
      ],
      stock_status_options: [
        {
          value: null,
          text: "All Stock Status"
        },
        {
          value: "-",
          text: "-"
        },
        {
          value: "pending",
          text: "Pending"
        },
        {
          value: "available",
          text: "Available"
        },
        {
          value: "committed",
          text: "Committed"
        }
      ],

      fulfilment_status_options: [
        {
          value: null,
          text: "All Fulfilment Status"
        },
        {
          value: "fulfiled",
          text: "Fulfilled"
        },
        {
          value: "pending",
          text: "Pending"
        }
      ],

      tracking_status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "In_Transit",
          text: "In_Transit"
        },
        {
          value: "Successful",
          text: "Successful"
        },
        {
          value: "Cancelled",
          text: "Cancelled"
        },
        {
          value: "Shipped_Ext",
          text: "Shipped_Ext"
        },
        {
          value: "Returned_to_Warehouse",
          text: "Returned_to_Warehouse"
        },
        {
          value: "Rescheduled",
          text: "Rescheduled"
        },
        {
          value: "Unsuccessful_Delay",
          text: "Unsuccessful_Delay"
        },
        {
          value: "Unsuccessful_Other",
          text: "Unsuccessful_Other"
        },
        {
          value: "Unsuccessful_Reject",
          text: "Unsuccessful_Reject"
        },
        {
          value: "Hold",
          text: "Hold"
        },
        {
          value: "Unsuccessful_Unreach",
          text: "Unsuccessful_Unreach"
        },
        {
          value: "Ready_for_Fulfilment",
          text: "Ready_for_Fulfilment"
        },
        {
          value: "Ready_for_Shipment",
          text: "Ready_for_Shipment"
        },
        {
          value: "Ready_for_Redemption",
          text: "Ready_for_Redemption"
        },
        {
          value: "Redemption_Reserved",
          text: "Redemption_Reserved"
        },
        {
          value: "Redemption_Checked-In ",
          text: "Redemption_Checked-In "
        },
        {
          value: "Redemption_Expired",
          text: "Redemption_Expired"
        },
        {
          value: "Redemption_Checked-Out",
          text: "Redemption_Checked-Out"
        },
        {
          value: "Redemption_Collected",
          text: "Redemption_Collected"
        },
        {
          value: "Redemption_Autovoided",
          text: "Redemption_Autovoided"
        },
        {
          value: "Redemption_Returned",
          text: "Redemption_Returned"
        },
        {
          value: "Redemption_Abnormal",
          text: "Redemption_Abnormal"
        },
        {
          value: "Redemption_CancelledCustomer",
          text: "Redemption_CancelledCustomer"
        },
        {
          value: "Redemption_Cancelled",
          text: "Redemption_Cancelled"
        }
      ],
      history_record_option: [
        {
          value: 'show_by_date',
          text: 'Show By Date'
        },
        {
          value: 'show_history_record',
          text: 'Show History Record'
        }
      ],

      tracking_tier_options: [
        {
          value: null,
          text: "All Tier",
        },
        {
          value: "1",
          text: "Tier - L1",
        },
        {
          value: "2",
          text: "Tier - L2",
        },
        {
          value: "3",
          text: "Tier - L3",
        },
      ],

      // tracking_status_options: [
      //   {
      //     value: null,
      //     text: "All Status"
      //   },
      //   {
      //     value: "Non-successful",
      //     text: "Non-successful"
      //   },
      //   {
      //     value: "processed",
      //     text: "Processed"
      //   },
      //   {
      //     value: "ready_for_shipment",
      //     text: "ready_for_shipment"
      //   },
      //   {
      //     value: "ready_for_fulfilment",
      //     text: "ready_for_fulfilment"
      //   },
      //   {
      //     value: "pending",
      //     text: "Pending"
      //   },
      //   {
      //     value: "in_transit",
      //     text: "In-Transit"
      //   },
      //   {
      //     value: "successful",
      //     text: "Successful Delivery"
      //   },
      //   {
      //     value: "shipped_at",
      //     text: "Shipped at"
      //   },
      //   {
      //     value: "returned_to_warehouse",
      //     text: "Returned to Warehouse"
      //   },
      //   {
      //     value: "return_to_warehouse",
      //     text: "Returning to Warehouse"
      //   },
      //   {
      //     value: "reschedule",
      //     text: "Reschedule"
      //   },
      //   {
      //     value: "unreach",
      //     text: "Unreach"
      //   },
      //   {
      //     value: "reject",
      //     text: "Reject"
      //   },
      //   {
      //     value: "delay",
      //     text: "Delay"
      //   },
      //   {
      //     value: "other",
      //     text: "Other"
      //   }
      // ],

      check_all_rows: false,
      outstanding_order_cnts: {},
      outstanding_stock_cnts: {},
      outstanding_fulfilment_cnts: {},
      bo_cnts: {},
      route_counts: {},
      route_ctns_counts: {},
      carton_cnt_checked: false,
    };
  },
  async created() {
    await this.getCouriers();
    await this.getRouteAllocations();
    let routes_response = await this.getTrackingRoutes(
      this.$store.state.user_obj
    );

    this.search_tracking_route_options.push({
      value: null,
      text: "All Routes"
    });

    this.tracking_route_options.push({
      value: null,
      text: "-"
    });
    for (let i in routes_response.tracking_routes) {
      this.tracking_route_options.push({
        value: routes_response.tracking_routes[i].route_name,
        text: routes_response.tracking_routes[i].route_name
      });

      this.search_tracking_route_options.push({
        value: routes_response.tracking_routes[i].route_name,
        text: routes_response.tracking_routes[i].route_name
      });
    }

    let clients_response = await this.getClients_old(
      this.$store.state.user_obj
    );
    for (let i in clients_response.clients) {
      this.client_options.push({
        value: clients_response.clients[i].name,
        text:
          clients_response.clients[i].full_name +
          " (" +
          clients_response.clients[i].name +
          ")"
      });
    }

    this.initialized = true;
  },
  mounted() {
    // this.loader = this.$loading.show({
    //   isFullPage: true,
    //   canCancel: false
    // });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    }
  },
  methods: {
    openRescheduleModal() {
      // Get the list of selected tracking numbers
      this.selectedTrackingNumbers = this.items
        .filter(item => item.is_checked)
        .map(item => item.tracking_number);

      if (false && this.selectedTrackingNumbers.length === 0) {
        this.$bvToast.toast("Please select at least one tracking number.", {
          title: "No Selection",
          variant: "warning",
          solid: true,
        });
        return;
      }

      // Open the modal
      this.$bvModal.show("reschedule-modal");
    },

    clearRescheduleForm() {
      this.rescheduleDate = null;
      this.selectedTrackingNumbers = [];
    },

    async confirmReschedule() {
      if (!this.rescheduleDate) {
        this.$bvToast.toast("Please select a reschedule date.", {
          title: "Missing Date",
          variant: "warning",
          solid: true,
        });
        return;
      }

      // Call API to submit the reschedule request
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      const response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_reschedule.php",
        data: {
          tracking_numbers: this.selectedTrackingNumbers,
          reschedule_date: this.rescheduleDate,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      this.loader.hide();

      if (response.data.status === "success") {
        this.$bvToast.toast("Reschedule successful.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
        this.getRouteAllocations();
        this.$bvModal.hide("reschedule-modal");
      } else {
        this.$bvToast.toast(response.data.message || "Reschedule failed.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    displayDate(d) {
      if (d == '0000-00-00') {
        return "-";
      } else if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "-";
      }
    },

    async updateRoute() {
      if (!this.update_route_obj.tracking_number || !this.update_route_obj.tracking_number.trim()) {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Tracking Number is required",
          variant: "danger"
        });
        return;
      }

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "route_allocation_set.php",
        data: {
          search_criteria: this.search_criteria,
          tracking_number: this.update_route_obj.tracking_number,
          route: this.update_route_obj.route,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      if (response.data.status == "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Tracking Route Updated",
          variant: "success"
        });
        if (response.data.message && response.data.message != "") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.message
          });
        }

        this.update_route_obj.tracking_number = null;
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.message
        });
      }

      this.loader.hide();
      this.getRouteAllocations();
    },

    async removeRoute() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "route_allocation_remove.php",
        data: {
          tracking_number: this.update_route_obj.tracking_number,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      if (response.data.status == "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Tracking Route Updated",
          variant: "success"
        });
        if (response.data.message && response.data.message != "") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.message
          });
        }

        this.update_route_obj.tracking_number = null;
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.message
        });
      }

      this.loader.hide();
      this.getRouteAllocations();
    },

    async cancelRoute(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "route_allocation_cancel.php",
        data: {
          tracking_number: row_data.tracking_number,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getRouteAllocations();
    },

    async onSearchByRoute(cart_status, route) {
      this.search_criteria["status_selected"] = cart_status;
      this.search_criteria["route_selected"] = route;
      this.getRouteAllocations();
    },

    async getRouteAllocations() {
      // return;
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "route_allocation_get.php",
        data: {
          offset: this.table_offset,
          limit: this.sel_table_limit,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.items = response.data.trackings;
      this.total_rows = parseInt(response.data.total_rows);

      this.route_counts = response.data.route_counts;
      this.route_ctns_counts = response.data.route_ctns_counts;
      this.loader.hide();
    },

    async onExport() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      this.$http({
        baseURL: `${this.API_HOST}`,
        url: "route_allocation_get.php",
        method: "POST",
        data: {
          offset: 0,
          limit: 999999,
          mode: 'export',
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "route_allocation_report.xlsx");
        document.body.appendChild(link);
        link.click();
        this.loader.hide();
      });
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getRouteAllocations();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.sel_table_limit;
      this.getRouteAllocations();
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_checked) return "table-info";
    },

    async onBulkAction(bulk_action) {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let tracking_ids = [];
      for (let i in this.items) {
        if (this.items[i].is_checked) {
          tracking_ids.push(this.items[i].id);
        }
      }

      // call action
      let action_urls = {
        receive: "tracking_receive.php",
        commit: "tracking_commit.php",
        fulfill: "tracking_fulfil.php"
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "route_reserve.php",
        data: {
          search_criteria: this.search_criteria,
          tracking_ids: tracking_ids,
          client_id: this.$store.state.user_obj.client_id,
          status_to_update: bulk_action,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.loader.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Bulk Update Success",
        variant: "success"
      });
      this.getRouteAllocations();
    },
    async getCouriers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "couriers_get.php",
        data: {}
      });

      this.courier_options = [
        {
          value: null,
          text: "All Couriers"
        }
      ];

      for (let i in response.data.couriers) {
        let courier_obj = {
          value: response.data.couriers[i].short_name,
          text: response.data.couriers[i].long_name
        };

        this.courier_options.push(courier_obj);
      }
    },
    onChangeShowHistoryRecord(val) {
      if (val === 'show_history_record') {
        this.search_criteria.scheduled_delivery_date = ""
      }
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.span-status {
  display: none;
}

.container-status:hover .span-status {
  display: inline;
}

.row-status_cnt {
  display: flex;
}

.route_box {
  border: 1px solid #cacaca;
  border-radius: 2px;
  padding: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/RouteAllocation.vue